import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { ArrowBackIosRounded } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import NavigationMenu from "./NavigationMenu";

function Workplace({ children }) {
  const history = useHistory();
  const handleBack = () => {
    history.goBack();
  };
  return (
    <Dialog open={true} fullScreen>
      <DialogTitle component={Box} display="flex" alignItems="center" gap={2}>
        <IconButton onClick={handleBack}>
          <ArrowBackIosRounded />
        </IconButton>
        <Typography variant="h6">Workplace Settings</Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ display: "flex", padding: 0 }}>
        <NavigationMenu />
        <Box flex={1}>{children}</Box>
      </DialogContent>
    </Dialog>
  );
}

export default Workplace;
